import { useTranslation } from "react-i18next";
import { Grid } from "@mantine/core";
import { CampaignProductResults } from "src/graphql/generated/graphql";

import { getRecommendationColor, getStarColor } from "../../overview/results";
import { ReportSection } from "../components/ReportSection";
import { StatCard } from "../components/StatCard";

export interface ReportOutcomeProps {
    productResults?: CampaignProductResults;
}

export const ReportOutcome = ({ productResults }: ReportOutcomeProps) => {
    const { t } = useTranslation(["common"]);

    const recommendColor = getRecommendationColor(productResults?.wouldRecommendPercent);
    const averageRating = productResults?.totalRating ? productResults.totalRating / 2 : 0;

    return (
        <ReportSection title={t("campaign_report_outcome")}>
            <Grid>
                <Grid.Col sm={6} md={4}>
                    <StatCard
                        value={`${averageRating.toFixed(1)} / 5`}
                        label={t("campaign_report_avg_rating")}
                        valueColor={getStarColor(averageRating)}
                    />
                </Grid.Col>
                <Grid.Col sm={6} md={4}>
                    <StatCard
                        value={`${(productResults?.wouldRecommendPercent ?? 0).toFixed(0)} %`}
                        label={t("campaign_overview_customers_recommend")}
                        valueColor={recommendColor}
                    />
                </Grid.Col>
                <Grid.Col sm={6} md={4}>
                    <StatCard value={productResults?.approvedCount || 0} label={t("campaign_report_delivered_reviews")} />
                </Grid.Col>
            </Grid>
        </ReportSection>
    );
};
